export { extend } from './extend.js';
export { addFilesFromTemplate } from './add-files-from-template.js';
export { modifyExtensionsEntry } from './modify-extensions-entry.js';
